import { Dropdown } from "antd";
import useUserStore from "../../stores/store";
import { useEffect, useState } from "react";

/*Menu options*/
function getMenuItems(restaurantId = "", branchId = "", isSuperAdmin) {
  const waiterListUrl = isSuperAdmin ? `/waiter/list?restaurantId=${restaurantId}&branchId=${branchId}` : '/waiter/list';
  return [
    {
      key: "3",
      label: (
        <a href={waiterListUrl}>
          <div className="flex flex-row gap-2 justify-between items-center py-[4px]">
            Waiter List
            <img src="/images/icons/arrow-round.svg" className="w-[18px] h-[18px]" />
          </div>
        </a>
      ),
    },
  ];
}

export default function LayoutHeaderComponent({ restaurantId = "", branchId = "" }) {
  const { isSuperAdmin } = useUserStore();
  const [menuItems, setMenuItems] = useState(getMenuItems(restaurantId, isSuperAdmin));

  useEffect(() => {
    const tempMenuItems = getMenuItems(restaurantId, branchId, isSuperAdmin);
    if (isSuperAdmin) {
      setMenuItems([
        {
          key: "1",
          label: (
            <a rel="noopener noreferrer" href={`/restaurants/${restaurantId}/branch/${branchId}/floor-plan/add`}>
              <div className="flex flex-row gap-2 justify-between items-center py-[4px]">
                Floor Plan Setup
                <img src="/images/icons/arrow-round.svg" className="w-[18px] h-[18px]" />
              </div>
            </a>
          ),
        },
        ...tempMenuItems,
      ]);
    } else {
      setMenuItems(tempMenuItems);
    }
  }, [isSuperAdmin, restaurantId]);

  return (
    <div className="flex flex-row justify-between items-center px-[18px] mb-[12px]">
      <div className="text-[24px]">Manage Layout</div>
      <Dropdown menu={{ items: menuItems }} placement="bottomRight" trigger={['click']} className="cursor-pointer">
        <img src="/images/icons/table_management_widget.svg" className="w-[30px] h-[30px]" />
      </Dropdown>
    </div>
  );
}
